import { Text } from 'tombac';
import Styled from "./StyledRegistrationUi";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RegistrationConfirmation = ({
  email
}) => /*#__PURE__*/_jsx(Styled.Page, {
  "data-sentry-element": "unknown",
  "data-sentry-component": "RegistrationConfirmation",
  "data-sentry-source-file": "RegistrationConfirmation.tsx",
  children: /*#__PURE__*/_jsxs(Styled.Content, {
    $w: "850u",
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "RegistrationConfirmation.tsx",
    "data-sentry-element": "unknown",
    children: [/*#__PURE__*/_jsx(Styled.Heading, {
      level: 1,
      $mb: "1sp",
      "data-sentry-element": "unknown",
      "data-sentry-source-file": "RegistrationConfirmation.tsx",
      "data-sentry-element": "unknown",
      children: "Thank you for registration!"
    }), /*#__PURE__*/_jsxs(Styled.Heading, {
      as: "p",
      level: 2,
      $mb: "4sp",
      "data-sentry-element": "unknown",
      "data-sentry-source-file": "RegistrationConfirmation.tsx",
      "data-sentry-element": "unknown",
      children: ["Please, check your email", ' ', /*#__PURE__*/_jsx(Styled.Heading, {
        as: "span",
        $display: "inline",
        level: 2,
        variant: "danger",
        "data-sentry-element": "unknown",
        "data-sentry-source-file": "RegistrationConfirmation.tsx",
        "data-sentry-element": "unknown",
        children: email
      }), ' ', "to confirm your account."]
    }), /*#__PURE__*/_jsxs(Text, {
      $m: "0 auto",
      $w: "max-content",
      as: "p",
      variant: "secondary",
      "data-sentry-element": "Text",
      "data-sentry-source-file": "RegistrationConfirmation.tsx",
      "data-sentry-element": "Text",
      children: ["Haven't received the confirmation e-mail?", /*#__PURE__*/_jsx("br", {}), "Please contact us at", ' ', /*#__PURE__*/_jsx(Text, {
        as: "a",
        $display: "inline-block",
        fontWeight: "bold",
        href: "mailto:movesupport@tomtom.com",
        variant: "interactive",
        "data-sentry-element": "Text",
        "data-sentry-source-file": "RegistrationConfirmation.tsx",
        "data-sentry-element": "Text",
        children: "movesupport@tomtom.com"
      }), "."]
    })]
  })
});
export default RegistrationConfirmation;